import { render, staticRenderFns } from "./SpracheWaehlenModal.vue?vue&type=template&id=7af346ae"
import script from "./SpracheWaehlenModal.vue?vue&type=script&lang=js"
export * from "./SpracheWaehlenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports